import axios from "axios";
import { API_BASE_URL } from "../constants/apiConstants";

export function loginMedico(username, password) {
  const data = {
    username: username,
    password: password,
  };

  return axios
    .post(`${API_BASE_URL}Medicos/loginMedico`, data, {
      headers: {
        Accept: "text/plain",
        "Content-Type": "application/json",
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
}

export function envioMailReseteoContrasena(email) {
  return axios
    .post(
      `${API_BASE_URL}Medicos/EnvioMailReseteoContrasena`,
      { email },
      {
        headers: {
          Accept: "text/plain",
          "Content-Type": "application/json",
        },
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
}

export async function reseteoContrasena(token, nuevaContrasena) {
  const url = `${API_BASE_URL}Medicos/ReseteoContrasena`;

  const data = {
    token: token,
    password: nuevaContrasena,
  };

  try {
    const response = await axios.put(url, data, {
      headers: {
        Accept: "text/plain",
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    throw error;
  }
}